import * as t from 'io-ts';

export const PriceModificationDynamicType = t.type({
    name: t.union([t.string, t.null]),
    notes: t.union([t.string, t.null]),
});

export type PriceModification = t.TypeOf<typeof PriceModificationDynamicType>;
